import React from 'react';
import { Button, ButtonProps } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface EditButtonProps extends Omit<ButtonProps, 'onClick'> {
  route: string;
  label?: string;
  className?: string;
  customHandler?: () => void;
}

const EditButton: React.FC<EditButtonProps> = ({
  route,
  label = 'common.update',
  className = 'd-flex justify-content-end',
  customHandler,
  ...buttonProps
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    if (customHandler) {
      customHandler();
    } else {
      navigate(route);
    }
  };

  return (
    <div className={className}>
      <Button
        type="primary"
        size="large"
        icon={<EditOutlined />}
        onClick={handleClick}
        {...buttonProps}
      >
        {t(label)}
      </Button>
    </div>
  );
};

export default EditButton;
